(function() {
  angular.module('admin')
    .controller('addDsoAdminController', ['$uibModalInstance', '$uibModal', 'DsoUsers', '$scope','$timeout', 'dso',
      function($uibModalInstance, $uibModal, DsoUsers, $scope, $timeout, dso) {
        var vm = this;
        vm.user = {dsoProfile: {id: dso.id}};
        vm.running = false;
        vm.userManipulated = false;
        vm.close = close;
        vm.submit = submit;

        $scope.$on('authenticationChanged', () => {
          $uibModalInstance.dismiss();
        });
        function close() {
          $uibModalInstance.dismiss();
        }

        $scope.$on('authenticationChanged', () => {
          $uibModalInstance.dismiss();
        });

        function submit() {
          $scope.errorControl.showErrors();
          if ($scope.addDsoUserForm.$valid) {
            DsoUsers.addDsoAdmin(vm.user, (result) => {
              $uibModalInstance.close({add: true});
            }, (error) => {
              vm.running = false;
              throw error;
            });
          }
        }
      }]);
})();
